$(function ($) {
	"use strict";

	var sb = leica.pi.esm.listScrollbar; 
	var $window = $(window);

	var appendBar = function ($section) {
		var $listing = sb.getListDiv($section);
		var $bar = $listing.find('.fixed-scrollbar');
		if ($bar.length == 0) {
  			var fixedBarTemplate = '<div class="fixed-scrollbar"><div></div></div>';
			var fixedBarCSS = {display: 'none', overflowX: 'scroll', position: 'fixed', width: '100%', 'z-index': 90};
			var $bar = $(fixedBarTemplate).appendTo($listing).css(fixedBarCSS);

			var width = GetScrollbarWidth();
			if (width != 20) {
				// Change if not equal to the css value
				$listing.css({'padding-bottom': width + 'px'});
			}

			$bar.scroll(function () {
				sb.scroll($bar);
			});
		}

		$bar.data('verticalStatus', '');
		$bar.data('horizontalStatus', '');

		return $bar;
	};

	var fixWidth = function ($bar) {

		var $listing = sb.getListDiv($bar);
		if ($listing[0].scrollWidth <= $window.width()) {
			// Either the window is wide enough to not require a horizontal scrollbar
			//	or the list is not expanded (e.g. attachments)
			if ($bar.data('horizontalStatus') !== 'off') {
				$bar.data('horizontalStatus', 'off');
				$bar.hide();
				var $section = sb.getSection($listing);
				leica.pi.esm.columnNavigator.updateControls($section);
			}
			return;
		}

		if ($bar.data('horizontalStatus') !== 'on') {
			$bar.data('horizontalStatus', 'on');
			if ($bar.data('verticalStatus') === 'on')
				$bar.show();
		}

		$bar.children('div').height(1).width($listing[0].scrollWidth);
		$bar.width($listing.width()).scrollLeft($listing.scrollLeft());
	};

	var positionBar = function ($bar) {
		if ($bar.length) {
			var $listing = $bar.parent();
			var listingOffset = {top: $listing.offset().top, bottom: $listing.offset().top + $listing.height()};
			var viewOffset = {top: $window.scrollTop(), bottom: $window.scrollTop() + $window.height()};

			var $section = $listing.closest('.list-scrollbar-section');
			var $footer = $section.find('.ListFooter_clone');
			if ($footer.length && $footer.position().top) {
				viewOffset.bottom -= $footer.height();
			}

			if ((listingOffset.top > viewOffset.bottom) || (listingOffset.bottom < viewOffset.top)) {
				// Scrollbar is not visible
				if ($bar.data('verticalStatus') !== 'off') {
					$bar.data('verticalStatus', 'off');
					$bar.hide();
				}
				return;
			}

			// Scrollbar may be visible
			if ($bar.data('verticalStatus') !== 'on') {
				$bar.data('verticalStatus', 'on');
				if ($bar.data('horizontalStatus') !== 'on')
					return;
				$bar.show();
				sb.scroll($bar);
			}
			var scrollbarTopOffset;
			if (listingOffset.bottom < viewOffset.bottom) {
				// Scrollbar sits at bottom of view
				scrollbarTopOffset = listingOffset.bottom;
			} else {
				// Scrollbar sits atop paginator.
				scrollbarTopOffset = viewOffset.bottom - GetScrollbarWidth();
			}
			// Map to fixed position
			var scrollbarTop = scrollbarTopOffset - viewOffset.top;
			$bar.css({top: scrollbarTop});
		}
	};

	// New listing divs have been created
	$window.on('load tabChanged RefreshPaginator', function () {
		$('.list-scrollbar-section').each(function () {
			var $section = $(this);
			leica.pi.esm.floatingHeaders.listHeader.run($section);
	 		leica.pi.esm.floatingHeaders.ensureHeadersArePositionedCorrectly('load', $section);
			leica.pi.esm.columnNavigator.initialize($section);
			var $bar = appendBar($section);
			fixWidth($bar);
			positionBar($bar);
		});
	});

	// Resize (horizontal and/or vertical), or a list expanded and became visible
	$window.on('resize click.expand-section', function () {
		$('.fixed-scrollbar').each(function () {
			var $bar = $(this);
			var $section = sb.getSection($bar);
	 		leica.pi.esm.floatingHeaders.ensureHeadersArePositionedCorrectly('load', $section);
			fixWidth($bar);
			positionBar($bar);
			sb.scroll($bar);
		});
	});

 	var scrollTimeout = true;
	$window.on('scroll.fixedbar', function () {
		// Throttle the window scrolling to (up to) 60 a second
		// Horizontal scrolling does not affect our listing, vertical scrolling will cause repositioning.
		if (scrollTimeout) {
			requestAnimationFrame(function () {
				$('.fixed-scrollbar').each(function () {
					var $bar = $(this);
					var $section = sb.getSection($bar);
	 				leica.pi.esm.floatingHeaders.ensureHeadersArePositionedCorrectly('scroll', $section);
					positionBar($bar);
				});
				scrollTimeout = true;
			});
			scrollTimeout = false;
		}
	});
});

leica.pi.esm.listScrollbar = (function() {
	"use strict";
	var sb = {};

	// Scroll the list that contains $bar
	sb.scroll = function($bar) {
		if ($bar.css('display') === 'none') {
			return;
		}
		var $listing = sb.getListDiv($bar);
		var $section = sb.getSection($listing);
		var leftPos = $bar.scrollLeft();

 		$listing.scrollLeft(leftPos);
	 	leica.pi.esm.floatingHeaders.scroll($section, leftPos);

	 	// Ensure proper placement of the fixed column
		$listing.find('thead th.fixed-column > div, tbody td.fixed-column, .summary-row td').css('left', leftPos);

		leica.pi.esm.columnNavigator.updateControls($section);
	}

	// Scroll the list under $section by leftPos
	sb.scrollSection = function($section, leftPos) {
		var $bar = $section.find('.fixed-scrollbar');
		$bar.scrollLeft(leftPos);
		sb.scroll($bar);
	}

	// Return the section containing $obj
	sb.getSection = function($obj) {
		return $obj.closest('.list-scrollbar-section');
	}

	// return the listing div that's contained in the passed section, or that contains $obj
	sb.getListDiv = function($obj) {
		if ($obj.hasClass('list-scrollbar-section'))
			return $obj.find('.fixed-scrollbar-container');
		// else assume object is a descendant
			return $obj.closest('.fixed-scrollbar-container');
	}
	// return the scrollbar contained in $obj
	sb.getScrollbar = function($obj) {
		return $obj.find('.fixed-scrollbar');
	}

	return sb;
}());

